import React from 'react';
import style from './Loader.scss';
var Loader = function (_a) {
    var _b = _a.loading, loading = _b === void 0 ? true : _b;
    return loading ? React.createElement("div", { className: style.loader }) : null;
};
export default Loader;
